export var hardBreak = function hardBreak(_node) {
  return '\n';
};